import { bindable } from 'aurelia';

// Share buttons for an event link: the native share sheet where the browser has one (mobile), otherwise
// WhatsApp, Facebook and copy link. Used by the present page and the share page so both offer the same options.
export class ShareButtons {
    @bindable public shareUrl: string = '';
    @bindable public shareTitle: string = '';

    public copyLinkSuccess: boolean = false;

    public get supportsNativeShare(): boolean {
        return typeof navigator.share === 'function';
    }

    public get facebookShareUrl(): string {
        return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}`;
    }

    public get whatsappShareUrl(): string {
        return `https://wa.me/?text=${encodeURIComponent(this.shareTitle + ' ' + this.shareUrl)}`;
    }

    public async share(): Promise<void> {
        if (this.supportsNativeShare) {
            try {
                await navigator.share({ title: this.shareTitle, url: this.shareUrl });
            } catch {
                // User cancelled or share failed — ignore
            }
            return;
        }
        // Fallback: copy to clipboard
        try {
            await navigator.clipboard.writeText(this.shareUrl);
            this.copyLinkSuccess = true;
            setTimeout(() => { this.copyLinkSuccess = false; }, 2500);
        } catch {
            // ignore
        }
    }
}
